import { SEARCH_RESULTS_TYPE } from 'Enum/SearchResults';
import {
  AppliesIcon,
  ClaimsSearchResult,
  CompassSearchResult,
  DocumentsSearchResult,
  EquipmentSearchResult,
  LongTermIcon,
  MedicalReferralsIcon,
  MedicationsSearchResult,
  PaymentsAndDeductionsIcon,
  PayslipsSearchResult,
  TreatmentSearchResult,
  YourTeamSearchResult,
} from 'Images';

export const getSearchResultIcon = (type: number): string => {
  switch (type) {
    case SEARCH_RESULTS_TYPE.MEDICAL_REFERRAL:
      return MedicalReferralsIcon;
    case SEARCH_RESULTS_TYPE.APPLIES:
      return AppliesIcon;
    case SEARCH_RESULTS_TYPE.LONG_TERM_EQUIPMENT:
      return LongTermIcon;
    case SEARCH_RESULTS_TYPE.PAYMENTS_AND_DEDUCTIONS:
      return PaymentsAndDeductionsIcon;
    case SEARCH_RESULTS_TYPE.YOUR_TEAM:
      return YourTeamSearchResult;
    case SEARCH_RESULTS_TYPE.COMPASS:
      return CompassSearchResult;
    case SEARCH_RESULTS_TYPE.DOCUMENTS:
      return DocumentsSearchResult;
    case SEARCH_RESULTS_TYPE.PAYSLIPS:
    case SEARCH_RESULTS_TYPE.FORM106:
      return PayslipsSearchResult;
    case SEARCH_RESULTS_TYPE.TREATMENTS_ENTITLEMENTS:
    case SEARCH_RESULTS_TYPE.TREATMENTS_ORDERS:
      return TreatmentSearchResult;
    case SEARCH_RESULTS_TYPE.CLAIMS_EVENTS:
      return ClaimsSearchResult;
    case SEARCH_RESULTS_TYPE.ELIGIBLE_MEDICATIONS:
    case SEARCH_RESULTS_TYPE.PRESCRIPTIONS_ORDERS:
      return MedicationsSearchResult;
    case SEARCH_RESULTS_TYPE.AVAILABLE_CONS_EQUIPMENT:
    case SEARCH_RESULTS_TYPE.CONS_EQUIPMENT_ORDERS:
      return EquipmentSearchResult;
    default:
      return AppliesIcon;
  }
};
